import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Button } from '../../../components/Button/Button';
import { StyledModal } from '../../../components/StyledModal/StyledModal';
import TextArea from 'antd/lib/input/TextArea';
import { IGrowerResponse } from '../../../logic/Models/Responses/GrowerResponse';
import { useLoadingCounter } from '../../../logic/Utility/useLoadingCounter';
import { IJdConnectInvitationRequest } from '../../../logic/store/Grower/JdConnectThunks';
import { CoveringLoader } from '../../../components/LoadingSpinner/CoveringLoader';
import { ScaleLoader } from 'react-spinners';

export interface IJdConnectInvitationModalProps
{
	grower: IGrowerResponse;
	visible: boolean;
	onCancel: () => void;
	getInvitation: (arg: IJdConnectInvitationRequest) => void;
}

export const JdConnectInvitationModal = (props: IJdConnectInvitationModalProps) =>
{
	const { grower, visible, onCancel, getInvitation } = props;

	const [qrCode, setQrCode] = useState<string>(undefined);
	const [link, setLink] = useState<string>(undefined);
	const [errorMessage, setErrorMessage] = useState<string>(undefined);

	// When loading > 0 a blocking spinner will show
	const { isLoading, startLoading, endLoading } = useLoadingCounter();

	const theme = useTheme();

	const copyToClipboard = () =>
	{
		navigator.clipboard.writeText(link);
	};

	useEffect(() =>
	{
		if (visible)
		{
			getInvitation(
				{
					GrowerId: grower?.Id,
					SetLink: setLink,
					SetQrCode: setQrCode,
					SetErrorMessage: setErrorMessage,
					StartLoading: startLoading,
					EndLoading: endLoading
				}
			);
		}

	},[visible]);

	const onClose = () =>
	{
		setQrCode(undefined);
		setLink(undefined);
		setErrorMessage(undefined);
		onCancel();
	};

	return (
		<StyledModal
			title={
				<div style={{
					fontWeight: theme.fontWeights.bold,
					fontFamily: theme.fonts.heading,
					fontSize: theme.fontSizes.xLarge,
					paddingTop: 10,
				}}>{`Add ${grower?.Name}'s John Deere Ops Data`}</div>
			}
			open={visible}
			width={750}
			flexBody={true}
			height={'47vh'}
			closable={true}
			onCancel={onClose}
			destroyOnClose={true}
		>
			{
				errorMessage &&
				<div style={{ marginBottom: 10, color: theme.colors.redDM }}>
					{errorMessage}
				</div>
			}
			{
				!isLoading && qrCode && link &&
				<div style={{ display: 'flex', flexDirection: 'column', marginTop: -30 }}>
					<div style={{ marginBottom: 10 }}>
						You can send this link or QR Code to the grower. On scanning the QR code, a login page to John Deere will open on their device's browser.
					</div>
					<TextArea value={link} style={{ marginBottom: 10 }} readOnly autoSize />
					<div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10, alignItems: 'center' }}>
						<Button variant='main' width={'150px'} onClick={copyToClipboard} style={{ marginBottom: 10 }}>Copy Link</Button>
					</div>
					<img src={`data:image/png;base64,${qrCode}`} alt="QR Code" style={{ width: 200, height: 200, alignSelf: 'center' }} />
					<div style={{ marginTop: 'auto' }}>
						<Button variant='dark' width={'100%'} onClick={onCancel}>Close</Button>
					</div>
				</div>
			}
			<CoveringLoader style={{ zIndex:999 }} duration={10} className={isLoading ? 'loading' : ''}>
				<ScaleLoader color={theme.colors.primary} loading={true} />
			</CoveringLoader>
		</StyledModal>
	);
};